import axiosInstance from './axios-instance';

const getLoginStats = async (params = {}) => {
    return await axiosInstance({ url: '/app/metrics/login-stats', method: 'GET', params }).then(r => r.data);
};

const getFormStats = async (params = {}) => {
    return await axiosInstance({ url: '/app/metrics/form-stats', method: 'GET', params }).then(r => r.data);
};

const getKaimahiStats = async (params) => {
    return await axiosInstance({ url: '/app/metrics/kaimahi-stats', method: 'GET', params }).then(r => r.data);
};

export default { getLoginStats, getFormStats, getKaimahiStats };
